<template>
    <v-select v-model="vehicle_category_id" placeholder="Chọn loại xe" :reduce="name => name.id" label="name"
              :options="vehicle_categories">
        <span slot="no-options">Không tìm thấy</span>
    </v-select>
</template>

<script>
    import {RepositoryFactory} from "../services";
    import {MixinHelper} from "../services";

    const repo = RepositoryFactory.get('vehicle_categories');
    export default {
        name: "SelectorVehicleCategory",
        mixins:[MixinHelper],
        props: {
            value: {
                type: Number
            }
        },
        data() {
            return {
                vehicle_categories: [
                    {id: 0, name: 'Tất cả xe'}
                ]
            }
        },
        created() {
            this.list();
        },
        methods: {
            list() {
                repo.list()
                    .then(res => {
                        this.vehicle_categories = [...this.vehicle_categories, ...this.getProp(res, 'data.datas', [])];
                    })
                    .catch(err => {
                    })
            },
        },
        computed: {
            vehicle_category_id: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                }
            }
        }
    }
</script>

<style scoped>

</style>
